export default "__VITE_ASSET__53f23b96__"